import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const ContentLayout = ({ children, title, url }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ paddingLeft: 5, paddingRight: 5, paddingTop: 2, paddingBottom: 5, margin: '0 auto', backgroundColor: '#ECEFF1' }}>
        
      <Typography variant="h2" gutterBottom>
        
        {url && 
        <IconButton aria-label="back" onClick={() => navigate(url)}>
          <ArrowBackIcon />
        </IconButton>
        }
        {title}
      </Typography>

      {children}
    </Box>
  );
};

export default ContentLayout;